"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var constants_1 = require("./constants");
var moduleState = function (rootState) { return rootState[constants_1.namespace]; };
exports.isConnected = reselect_1.createSelector(moduleState, function (state) { return state.isConnected; });
exports.isAvailable = reselect_1.createSelector(moduleState, function (state) { return state.isAvailable; });
//# sourceMappingURL=selectors.js.map